<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.fullPath"
          :class="isActive(tag)?'active':''"
          :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
          tag="span"
          class="tags-view-item"
          @click.middle.native="closeSelectedTag(tag)"
          @contextmenu.prevent.native="openMenu(tag,$event)">
        {{tag.title}}
        <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"/>
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
  import ScrollPane from "./ScrollPane";

  export default {
    components: {ScrollPane},
    data() {
      return {
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {},
        affixTags: [],
      };
    },
    computed: {
      visitedViews() {
        return this.$store.state.tagsView.visitedViews;
      },
      routes() {
        return this.$store.state.permission.routes;
      },
    },
    watch: {
      $route() {
        this.addTags();
        this.moveToCurrentTag();
      },
      visible(value) {
        if (value) {
          document.body.addEventListener("click", this.closeMenu);
        } else {
          document.body.removeEventListener("click", this.closeMenu);
        }
      },
    },
    mounted() {
      this.initTags();
      this.addTags();
      this.$bus.$on("closeTag", view => {
        this.closeSelectedTag(view);
      });
    },
    methods: {
      isActive(route) {
        return route.fullPath === this.$route.fullPath;
      },
      initTags() {
        let visitedViewsStr = window.localStorage.getItem("visitedViews");
        if (visitedViewsStr) {
          let visitedViews = JSON.parse(visitedViewsStr);
          visitedViews.forEach(item => {
            this.$store.dispatch("tagsView/addView", item);
          });
        } else {
          let temp = {
            fullPath: "/",
            path: "/",
            name: "Home",
            meta: {
              title: "首页",
              affix: true,
            },
          };
          this.$store.dispatch("tagsView/addVisitedView", temp);
        }
      },
      addTags() {
        const {name} = this.$route;
        if (name) {
          this.$store.dispatch("tagsView/addView", this.$route);
        }
        return false;
      },
      moveToCurrentTag() {
        let tags = this.$refs.tag;
        if (!tags) {
          return;
        }
        if (!Array.isArray(tags)) {
          tags = [tags];
        }
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.fullPath === this.$route.fullPath) {
              this.$refs.scrollPane.moveToTarget(tag);
              this.$store.dispatch("tagsView/updateVisitedView", this.$route);
              break;
            }
          }
        });
      },
      refreshSelectedTag(view) {
        this.$store.dispatch("tagsView/delCachedView", view).then(() => {
          const {fullPath} = view;
          this.$nextTick(() => {
            this.$router.replace({
              path: "/redirect" + fullPath,
            });
          });
        });
      },
      closeSelectedTag(view) {
        this.$store.dispatch("tagsView/delView", view).then(({visitedViews}) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews);
          }
        });
      },
      closeOthersTags() {
        this.$router.push(this.selectedTag);
        this.$store.dispatch("tagsView/delOthersViews", this.selectedTag).then(() => {
          this.moveToCurrentTag();
        });
      },
      closeAllTags(view) {
        this.$store.dispatch("tagsView/delAllViews").then(({visitedViews}) => {
          if (this.affixTags.some(tag => tag.path === view.path)) {
            return;
          }
          this.toLastView(visitedViews);
        });
      },
      toLastView(visitedViews) {
        const latestView = visitedViews.slice(-1)[0];
        if (latestView) {
          this.$router.push(latestView);
        } else {
          // You can set another route
          this.$router.push("/");
        }
      },
      openMenu(tag, e) {
        const menuMinWidth = 105;
        const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
        const offsetWidth = this.$el.offsetWidth; // container width
        const maxLeft = offsetWidth - menuMinWidth; // left boundary
        const left = e.clientX - offsetLeft + 15; // 15: margin right

        if (left > maxLeft) {
          this.left = maxLeft;
        } else {
          this.left = left;
        }

        this.top = e.clientY;
        this.visible = true;
        this.selectedTag = tag;
      },
      closeMenu() {
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../style/variables";

  .tags-view-container {
    width: calc(100% - 150px);

    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        height: $header-height;
        line-height: $header-height;
        color: #4B5666;
        padding: 0 15px;
        font-size: 13px;
        font-weight: 600;

        &:last-of-type {
          margin-right: 15px;
        }

        &.active {
          background-color: #eaedf2;
          color: #2D8CF0;
        }
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 1px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, .3);

      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>

<style lang="scss">
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 13px;
        height: 13px;
        line-height: 13px;
        border-radius: 50%;
        margin-right: -5px;
        text-align: center;
        font-size: 12px;

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>
